export default __webpack_public_path__ + "static/media/eyeClosed.dc1b9f28.svg";